import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import i18n from './i18n'
import Notifications from '@kyvg/vue3-notification'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import 'floating-vue/dist/style.css'
import { VueQueryPlugin } from '@tanstack/vue-query'
import FloatingVue from 'floating-vue'

const app = createApp(App).use(i18n)
app.config.globalProperties.axios = axios
app.use(VCalendar, {})
app.use(FloatingVue)
app.use(store)
app.use(router)
app.use(VueSweetalert2)
app.use(CoreuiVue)
app.use(Notifications)
app.use(VueQueryPlugin)
app.provide('icons', icons)
app.component('CIcon', CIcon)

app.mount('#app')
